import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";

const FORM_CODE = "findCheaper";

export default function FindLowPrice() {
  return (
    <PopupFormWrapper
      code={FORM_CODE}
      goalOpen={GOALS.findLowPriceOpen}
      extraData={({ popupData }) =>
        popupData?.name ? { form_text_29: popupData.name } : null
      }
      goalSent={GOALS.findLowPriceSent}
    />
  );
}
